import IconName from './NameIcon';

export default IconName;
